import { defineComponent as _defineComponent } from 'vue'
import { getRecordIdApi, saveAsrRtResultApi } from '@/api/asr'
import { IS_DEV } from '@/const'
// import ClipboardJS from 'clipboard'
import { Message, MessageBox } from 'element-ui'
import { computed, onBeforeUnmount, onUnmounted, ref, shallowRef } from 'vue'
import dayjs from 'dayjs'
import CommonFormItems from '../components/CommonFormItems.vue'
import { IAsrResult, useAsrWebsocket, useRecorder, EnumAsrWebsocketStatus, AsrRtTaskStatusEnum, EnumRecorderStatus } from './utils'
import { AsrRtModule } from '@/store/modules/asr-rt'
import StopDialog from './components/saveDialog.vue'
import SaveTipDialog from '../components/SaveTipDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const task = ref<{
  lang: 'cn' | 'eng',
  property: string,
}>({
  lang: 'cn',
  property: '',
})

const isGoing = computed(() => wsStatus.value === EnumAsrWebsocketStatus.Going || wsStatus.value === EnumAsrWebsocketStatus.Ending)

function getWsBaseUrl() {
  const isSSL = location.protocol === 'https:'
  const baseApi = process.env.VUE_APP_BASE_API
  return `${isSSL ? 'wss' : 'ws'}://${location.host}${IS_DEV ? '/socket' : `${baseApi}`}`
}

const wsUrl = computed(() => {
  if(recordId.value) {
    return `${getWsBaseUrl()}/ws/asr/freetalk/${recordId.value}`
  }
  return ''
})
const {
  status: wsStatus,
  start: wsStart,
  stop: wsStop,
  sendAudioStream,
  destroy: wsDestroy
} = useAsrWebsocket(wsUrl, appendTransText, () => destroy(), onWsError, getTransTimeInfo)

let reconnectTimes = 0
const maxReconnectTimes = 5
const isWsError = ref(false)
function onWsError(isWsConnectError?: boolean) {
  console.log('isWsConnectError: ', isWsConnectError)
  if(isWsConnectError) {
    isWsError.value = true
    console.log('连接发生错误')
    if(reconnectTimes < maxReconnectTimes) {
      setTimeout(() => {
        // 如果录音机关闭了，重启一下
        if(recorderStatus.value === EnumRecorderStatus.Init) {
          start().then(() => {
            wsStart()
            reconnectTimes++
          })
        }
      }, 2000)
    } else {
      console.log('重连超过最大次数')
      MessageBox.confirm('与服务器断开连接，实时识别已保存到结果列表，点击刷新重试', '提示', {
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: '重试'
      }).then(() => {
        isWsError.value = false
        AsrRtModule.ToggleNeedAlert(false)
        resetPage()
      })
    }
  } else if(taskStatus.value === AsrRtTaskStatusEnum.INIT) {
    // 初始化时就报错，可能是服务问题或者参数问题
    console.log('初始化连接后还没开始识别就出现错误')
    AsrRtModule.ToggleNeedAlert(false)
  }
}

const transTextList = ref<(IAsrResult)[]>([])
function appendTransText(rs: IAsrResult) {
  const last = transTextList.value.at(-1)
  if(last && last.startTime === rs.startTime && !last.isFinal) {
    transTextList.value.splice(transTextList.value.length - 1, 1, rs)
  } else {
    transTextList.value.push(rs)
  }
}

// let MAX_DURATION = 7200 // 2 hour
// FIXME: 测试数据
// let MAX_DURATION = 30 // 30s
const taskStatus = ref<AsrRtTaskStatusEnum>(AsrRtTaskStatusEnum.INIT)
const isOvertime = ref(false)
// 获取用于已经转写的时长信息
function getTransTimeInfo(timestamp?: number, isOvertimeVal?: boolean) {
  if(timestamp) {
    isOvertime.value = isOvertimeVal ?? false
    if(isOvertimeVal) {
      pauseTask()
      MessageBox.alert('单次实时识别试用上限为2h，已达到上限停止识别。', {
        title: '提示',
        type: 'warning',
        closeOnClickModal: true
      }).catch(() => {})
    }
  }
}
const { start, stop, destroy, status: recorderStatus } = useRecorder({
  onProgress: (buffer) => {
    if(wsStatus.value === EnumAsrWebsocketStatus.Going) {
      taskStatus.value = AsrRtTaskStatusEnum.GOING
      sendAudioStream(buffer)
    }
  },
  onDeviceError: () => {
    if(wsStatus.value !== EnumAsrWebsocketStatus.Init) {
      taskStatus.value = taskStatus.value === AsrRtTaskStatusEnum.GOING ? AsrRtTaskStatusEnum.PAUSED : AsrRtTaskStatusEnum.INIT
      Message.error('连接麦克风失败，停止转写！')
      wsStop()
    }
  }
})

const recordId = ref('')
function getRecordId(p: string) {
  if(taskStatus.value === AsrRtTaskStatusEnum.PAUSED) {
    // 恢复识别
    return Promise.resolve()
  }
  return getRecordIdApi(p).then(({ data }) => {
    recordId.value = data
  })
}

// 结束识别弹窗
const saveDialog = ref({
  visible: false,
  taskName: '',
  saveLoading: false,
  cancelSaveLoading: false
})
function updateTaskName() {
  const timeStr = dayjs().format('YYYYMMDDHHmmss')
  const taskName = `实时识别${timeStr}`
  saveDialog.value.taskName = taskName
}
async function handleSubmit() {
  saveDialog.value.saveLoading = true
  try {
    const params = {
      recordId: recordId.value,
      name: saveDialog.value.taskName,
      save: true
    }
    await saveAsrRtResultApi(params)
    resetPage()
    saveDialog.value.saveLoading = false
  } catch (error) {
    console.log('error: ', error)
    saveDialog.value.saveLoading = false
  }
  isOvertime.value = false
}
async function cancelSubmit() {
  saveDialog.value.cancelSaveLoading = true
  try {
    const params = {
      recordId: recordId.value,
      name: saveDialog.value.taskName,
      save: false
    }
    await saveAsrRtResultApi(params)
  } catch (error) {
    console.log('error: ', error)
  }
  saveDialog.value.cancelSaveLoading = false
  isOvertime.value = false
  resetPage()
}
const commonFormItemsRef = shallowRef<InstanceType<typeof CommonFormItems>>()
function resetPage() {
  saveDialog.value.visible = false
  taskStatus.value = AsrRtTaskStatusEnum.INIT
  transTextList.value = []
  task.value.lang = 'cn'
  commonFormItemsRef.value?.onLangChange('cn')
  AsrRtModule.ToggleNeedAlert(false)
}
const startBtnLoading = ref(false)
function startTask() {
  // if(!task.value.property) {
  //   Message.error('请先选择专业领域！')
  //   return
  // }
  // if(isLimitDuration()) return
  if(isOvertime.value) return
  startBtnLoading.value = true
  start().then(() => {
    updateTaskName()
    AsrRtModule.ToggleNeedAlert(true)
    getRecordId(task.value.lang).then(() => {
      wsStart()
    }).catch((e) => {
      console.log('e: ', e)
      AsrRtModule.ToggleNeedAlert(false)
      stop()
      throw e
    }).finally(() => {
      startBtnLoading.value = false
    })
  })
}

function stopTask() {
  pauseTask()
  saveDialog.value.visible = true
}
function pauseTask() {
  taskStatus.value = AsrRtTaskStatusEnum.PAUSED
  isWsError.value = false
  stop()
  wsStop()
}

const resultWrapRef = shallowRef<HTMLDivElement>()

onBeforeUnmount(() => {
  AsrRtModule.ToggleNeedAlert(false)
})
onUnmounted(() => {
  destroy()
  wsDestroy()
})


return { __sfc: true,task, isGoing, getWsBaseUrl, wsUrl, wsStatus, wsStart, wsStop, sendAudioStream, wsDestroy, reconnectTimes, maxReconnectTimes, isWsError, onWsError, transTextList, appendTransText, taskStatus, isOvertime, getTransTimeInfo, start, stop, destroy, recorderStatus, recordId, getRecordId, saveDialog, updateTaskName, handleSubmit, cancelSubmit, commonFormItemsRef, resetPage, startBtnLoading, startTask, stopTask, pauseTask, resultWrapRef, CommonFormItems, EnumAsrWebsocketStatus, AsrRtTaskStatusEnum, StopDialog, SaveTipDialog }
}

})